import type { DeviceListQuery } from './api/endpoints/devices';

/**
 * Every TanStack Query key in the console, in one place.
 *
 * Centralised because invalidation is the part that rots: a key spelled inline in two
 * components drifts, and then a mutation invalidates one of them. `as const` keeps the
 * tuples literal so a typo is a type error rather than a cache miss.
 */
export const queryKeys = {
  currentUser: ['currentUser'] as const,
  dashboard: ['dashboard'] as const,
  devices: (query: DeviceListQuery) => ['devices', query] as const,
  /**
   * Nested under 'devices' on purpose. A mutation that changes one device invalidates
   * { queryKey: ['devices'] } and reaches both the list and every open detail view, so a
   * revoke on the detail page cannot leave a stale row behind in the table.
   */
  device: (deviceId: string) => ['devices', 'detail', deviceId] as const,
  deviceTags: ['devices', 'tags'] as const,
  organizations: ['organizations'] as const,
  sites: (organizationId?: string) => ['sites', organizationId ?? 'all'] as const,
  deviceGroups: (organizationId?: string) => ['deviceGroups', organizationId ?? 'all'] as const,
  sessions: ['sessions'] as const,
  technicians: ['technicians'] as const,
  roles: ['roles'] as const,
  auditEvents: (search: string) => ['auditEvents', search] as const,
};
